// src/components/ProductReviewsDisplay.js
import React from 'react';

const bs = { fontFamily: "'Montserrat', sans-serif" };

const Stars = ({ rating }) => (
  <div style={{ display: 'flex', gap: '2px' }}>
    {[1,2,3,4,5].map(s => (
      <svg key={s} width="13" height="13" fill="currentColor" viewBox="0 0 20 20"
        style={{ color: s <= rating ? '#f59e0b' : '#e5e7eb' }}>
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.92 8.725c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z"/>
      </svg>
    ))}
  </div>
);

const ProductReviewsDisplay = ({ reviews }) => {
  if (!reviews?.length) {
    return (
      <p style={{ ...bs, color: '#bbb', fontSize: '12px', textAlign: 'center', padding: '16px 0' }}>
        Aún no hay reseñas. ¡Sé el primero en comentar!
      </p>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
      {reviews.map((r, i) => (
        <div key={i} style={{
          padding: '14px 0',
          borderBottom: i < reviews.length - 1 ? '1px solid #f5f0f0' : 'none',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', marginBottom: '6px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Stars rating={r.rating} />
              <span style={{ ...bs, fontSize: '12px', fontWeight: 600, color: '#060D14' }}>
                {r.reviewerName}
              </span>
            </div>
            <span style={{ ...bs, fontSize: '10px', color: '#ccc' }}>
              {new Date(r.date).toLocaleDateString('es-MX', {
                year: 'numeric', month: 'short', day: 'numeric' })}
            </span>
          </div>
          <p style={{ ...bs, fontSize: '12px', color: '#777', lineHeight: 1.65 }}>
            {r.comment}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ProductReviewsDisplay;
